import Parse from 'parse';

export const returnPendingReportSummary = (params) => {
  return Parse.Cloud.run('returnPendingReportSummary', params);
};

export const getPaymentsReport = (params) => {
  return Parse.Cloud.run('getPaymentsReport', params);
};

export const getReplacementReport = (params) => {
  return Parse.Cloud.run('getReplacementReport', params);
};
